module.exports = __webpack_public_path__ + "static/media/JustGoDemo.f0dcbe6d.mp4";